<div class="container section-gap">
  <div class="pictograph-container">
    <div class="row">
      <div class="col-lg-12 col-sm-12 col-12">
        <kla-title [lineConfig]="lineConfig" [config]="config.title" [showFooter]="false"></kla-title>
      </div>
    </div>
    <div class="pictograph-content">
      <div class="row">
        <div class="col-lg-4 col-sm-6 col-6 offset-lg-0" [ngClass]="{'offset-3': !showSecondPictograph }">
          <h4> {{activePictograph?.year}} {{activePictograph?.firstGraph?.description}} </h4>
          <div class="pictograph-icons">
            <i [class]="'icon-' + activePictograph?.firstGraph?.icon + ' icon'"
               *ngFor="let number of maxNumber; index as i"
               [ngStyle]="{'color': activePictograph?.firstGraph?.iconColor}"
               [ngClass]="{'blured': activePictograph.firstGraph.percentage < i + 1 }"></i>
          </div>
          <div class="pictograph-legend">
            <i [class]="'icon-' + activePictograph?.firstGraph?.icon"
               [ngStyle]="{'color': activePictograph?.firstGraph?.iconColor}"></i>
            <p> = {{activePictograph?.firstGraph?.subject}} {{activePictograph?.firstGraph?.percentage}} </p>
          </div>
        </div>

        <div class="col-lg-4 col-sm-6 col-6" *ngIf="showSecondPictograph">
          <h4>{{activePictograph?.year}} {{activePictograph?.secondGraph?.description}}</h4>
          <div class="pictograph-icons">
            <i [class]="'icon-' + activePictograph?.secondGraph?.icon + ' icon'"
               *ngFor="let number of maxNumber; index as i"
               [ngStyle]="{'color': activePictograph?.secondGraph?.iconColor}"
               [ngClass]="{'blured': activePictograph.secondGraph.percentage < i + 1 }"></i>
          </div>
          <div class="pictograph-legend">
            <i [class]="'icon-' + activePictograph?.secondGraph?.icon"
               [ngStyle]="{'color': activePictograph?.secondGraph?.iconColor}"
            ></i>
            <p> = {{activePictograph?.secondGraph?.subject}} {{activePictograph?.secondGraph?.percentage}} </p>
          </div>
        </div>

        <div class="col-lg-4 col-sm-12">
          <div class="slection-button" *ngFor="let item of pictographConfig?.data; index as i">
            <kla-round-button [title]="item?.year" [activeButton]="selectedButton == i"
                              (click)="changeActivePictograph(i)"></kla-round-button>
          </div>
        </div>

        <div class="footer-paragraph col-lg-8 col-12" *ngIf="config.title.footer">
          <app-dynamic-content
              [contentId]="'pictograph-footer'"
              [htmlContent]="config.title.footer">
            </app-dynamic-content>
        </div>

      </div>
    </div>
  </div>
</div>
